import { render, staticRenderFns } from "./lawbizparam.vue?vue&type=template&id=7d205090&scoped=true&"
import script from "./lawbizparam.vue?vue&type=script&lang=js&"
export * from "./lawbizparam.vue?vue&type=script&lang=js&"
import style0 from "./lawbizparam.vue?vue&type=style&index=0&id=7d205090&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d205090",
  null
  
)

export default component.exports